import { render, staticRenderFns } from "./block-document-general-info.vue?vue&type=template&id=a885156a&scoped=true&lang=pug"
import script from "./block-document-general-info.vue?vue&type=script&lang=js"
export * from "./block-document-general-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a885156a",
  null
  
)

export default component.exports